import { useCallback } from "react";
import { RecentlyOpenedItemConfigurationProps, useResolveRecentlyOpenedItemForPersistence } from "./useResolveRecentlyOpenedItemForPersistence";
import { useRecentlyOpenedResults } from "client/Features/Search/RecentSearch/Persistence/useRecentlyOpenedResults";
import { isNotNilOrWhiteSpace } from "client/Misc/utils";
import { navigateTo } from "client_legacy/ndaw/navigator";
import { AlertManager, useAlerts } from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";

export type IntegrationFlowNavigationHandlerProps = {
	link: string | null;
}
	& RecentlyOpenedItemConfigurationProps;

export function useIntegrationFlowNavigationHandler(props: IntegrationFlowNavigationHandlerProps): (() => void) {
	const {
		link
	} = props;

	const alertManager: AlertManager = useAlerts();
	const { registerFromRecentlyOpened: registerRecentlyOpenedItem } = useRecentlyOpenedResults();
	const recentlyOpenedItem = useResolveRecentlyOpenedItemForPersistence(props);

	return useCallback(
		(): void => {
			if (isNotNilOrWhiteSpace(link)) {
				registerRecentlyOpenedItem(recentlyOpenedItem);
				navigateTo(link, true);
			} else {
				alertManager.showError(localize("_ThisItemCantBeOpened"));
			}
		},
		[
			alertManager,
			link,
			recentlyOpenedItem,
			registerRecentlyOpenedItem
		]
	);
}